module.exports = __webpack_public_path__ + "img/Evoucher.83b96747.svg";